export default __webpack_public_path__ + "static/media/step3aDarkMode.d111ce0a.svg";